import { useContext } from 'react'
import { MessageContext } from '../components/container'

export const useMessage = () => {
  const { pushMessage, deleteMessage } = useContext(MessageContext)
  return { pushMessage, deleteMessage }
}
